import { render } from "./HeroiconsOutlineScissors.vue?vue&type=template&id=36dc5218"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineScissors.vue"]])

export default __exports__